import React from 'react';
import { Box, List, Text } from '@common-fe/common-fe';

import { SelfBlockWrapper } from '@/components/wrappers/BlockWrapper';

import EnrollmentsAccountHistoryItem from './EnrollmentsAccountHistoryItem';
import { useGetEnrollmentAccountHistoryQuery } from './queries';

interface Props {
  accountId?: string;
}

const EnrollmentsAccountHistory: React.FC<Props> = ({ accountId }) => {
  const { data, isLoading } = useGetEnrollmentAccountHistoryQuery({
    accountId,
  });
  if (isLoading || !data.length) {
    return null;
  }
  return (
    <SelfBlockWrapper title="Account status" moduleAnchorId="account_status">
      <Box
        direction="column"
        width="100%"
        justify="between"
        data-testid="enrollments-account-history_wrapper"
      >
        <Box
          background="canvas"
          pad="spacing16"
          round="container1Round"
          width="100%"
          border={{ size: '1px', color: 'border2' }}
          height="fit-content"
          data-testid="enrollments-account-history_container"
        >
          <Text
            size="small"
            weight="bold"
            color="textTitle"
            margin={{ bottom: 'xs' }}
            data-testid="enrollments-account-history_title"
          >
            Account status history
          </Text>

          <Box
            pad="spacing8"
            round="container2Round"
            background="module"
            data-testid="enrollments-account-history_list-container"
          >
            <List>
              <List.Header
                round="dropdownItemRound"
                pad={{ horizontal: 'spacing12' }}
                height="24px"
                data-testid="enrollments-account-history_list-header"
              >
                <List.Header.Item data-testid="enrollments-account-history_header-status">
                  Status
                </List.Header.Item>
                <List.Header.Item data-testid="enrollments-account-history_header-period">
                  Period
                </List.Header.Item>
              </List.Header>
              {data?.map((item, index) => (
                <EnrollmentsAccountHistoryItem isFirstItem={index === 0} key={item.id} {...item} />
              ))}
            </List>
          </Box>
        </Box>
      </Box>
    </SelfBlockWrapper>
  );
};

export default EnrollmentsAccountHistory;
